export const sliceArrayIntoGroups = (listItems, size) => {
  if (listItems.length === 0) { return listItems }

  return [
    listItems.slice(0, size),
    ...sliceArrayIntoGroups(listItems.slice(size), size)
  ]
}
